module.exports = __webpack_public_path__ + "knowledge.cLEtBEku.svg";